var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.labelEN))]),_c('p',{staticClass:"title-txt"},[_vm._v(_vm._s(_vm.labelJP))])])}
var staticRenderFns = []

export { render, staticRenderFns }